<template>
  <div class="article-slot-expanded-content__wrapper">
    <div
      class="article-slot-expanded-content__arrow-wrapper"
      @click="toggleExpandedContent"
    >
      <a-visibility hide :on="[$breakpoint.mobile]">
        <span
          class="article-slot-expanded-content__arrow-text text-secondary-button bold"
        >
          {{ expandedStateText }}
        </span>
      </a-visibility>

      <a-icon
        :icon="$options.consts.ICON.ARROW_DOWN_PURPLE"
        :width="16"
        :height="16"
        :original="true"
        :no-hover="true"
        class="article-slot-expanded-content__arrow"
        :class="arrowDynamicClass"
      />
    </div>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { propValidator, PROP_TYPES } from '@fmpedia/validators'

export default {
  name: 'ArticleSlotExpandedContent',
  components: { AIcon },
  consts: {
    ICON
  },
  props: {
    isContentExpanded: propValidator([PROP_TYPES.BOOLEAN], true)
  },
  computed: {
    expandedStateText() {
      return this.isContentExpanded ? 'Collapse' : 'Expand'
    },
    arrowDynamicClass() {
      return {
        expanded: this.isContentExpanded
      }
    }
  },
  methods: {
    toggleExpandedContent() {
      this.$emit('expanded-changed', !this.isContentExpanded)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/styles/_article-body.scss';

.article-slot-expanded-content__wrapper {
  .article-slot-expanded-content__arrow-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .article-slot-expanded-content__arrow {
    margin-left: 6px;

    &.expanded {
      transform: rotate(180deg);
    }
  }

  .article-slot-expanded-content__arrow-text {
    &:hover {
      color: $c--main;
      text-decoration: underline;
    }
  }
}
</style>
